const config = {
  // apiBaseUrl: 'http://192.168.0.10:8080',
  apiBaseUrl: 'https://dev-api.tretaderma.com',
};

export default config;
